import * as O from 'fp-ts/lib/Option';
import * as NEA from 'fp-ts/lib/NonEmptyArray';
import {AgentAgencyClaim} from 'Users/models/AgentAgencyClaim';
import {pipe} from 'fp-ts/lib/pipeable';
import {identity} from 'fp-ts/lib/function';

export const getIsNewYorkFromAgency = (agency: O.Option<AgentAgencyClaim>) =>
  pipe(
    agency,
    O.map(a => a.agentNumbers),
    O.chain(NEA.fromArray),
    O.map(NEA.head),
    O.map(a => a.isNewYork),
    O.fold(() => false, identity)
  );
